import moment from "moment";
import { AUTOMOTORES, COMBINADO_FAMILIAR, INCENDIO } from "../data/constants";

moment.locale("es");

const currencyFormat = (num) =>
    num ? "$" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : "$0";

const formatDate = (bdDate) => {
    let dateArray = bdDate.split("T")[0];
    dateArray = dateArray.split("-");

    const año = dateArray[0];
    const mes = dateArray[1];
    const dia = dateArray[2];

    return `${dia}/${mes}/${año}`;
};

const toMoment = (date) => moment(date, "DD-MM-YYYY");
const formatMoment = (date, format = "DD/MM/YY") => date.format(format);
const isBeforeToday = (date) => date.isBefore(moment());
const isAfterToday = (date) => date.isAfter(moment());

const cantMonthsBetweenDates = (date1, date2) =>
    moment(toMoment(date2)).diff(toMoment(date1), "months");

const detalleRiesgosURL = (ramo) => {
    if (ramo.nombre === AUTOMOTORES) return "/FetchResumenVehiculos";

    if (ramo.nombre === COMBINADO_FAMILIAR) return "/FetchCombinadoResumen";

    return ramo.nombre === INCENDIO
        ? "/FetchResumenIncendio"
        : "/FetchResumenRiesgosVarios";
};

const capitalize = (word) => word[0].toUpperCase() + word.substring(1);

const formatCUITCUILWithDash = (str) =>
    `${str.substring(0, 2)}-${str.substring(2, str.length - 1)}-${str.substring(
        str.length - 1,
        str.length
    )}`;

const truncate = (source, maxSize = 30) =>
    source.length > maxSize ? source.slice(0, maxSize - 1) + "…" : source;

const openPagosURL = (cuit,ramo,poliza,endoso) => {
    
    const baseUrl = process.env.REACT_APP_PAGOS_URL

    if(ramo && poliza && endoso){
        window.open(`${baseUrl}/#/?cuit=${cuit}&ramo=${ramo}&poliza=${poliza}&endoso=${endoso}`, "_blank");
    }else{
        if(ramo && poliza){
            window.open(`${baseUrl}/#/?cuit=${cuit}&ramo=${ramo}&poliza=${poliza}`, "_blank");
        }else{
            window.open(`${baseUrl}/#/?cuit=${cuit}`, "_blank");
        }
    }
};

export {
    currencyFormat,
    formatDate,
    capitalize,
    toMoment,
    formatMoment,
    isBeforeToday,
    isAfterToday,
    cantMonthsBetweenDates,
    detalleRiesgosURL,
    formatCUITCUILWithDash,
    truncate,
    openPagosURL,
};
